<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{
                            data_import_log.import_id ? $t("lang.edit_data_import_log") : $t("lang.add_data_import_log")
                        }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="data_import_log.import_id && data_import_log.import_id > 0"
                            @invoke-method="dbGetDataImportLog(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="data_import_log.import_id && data_import_log.import_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <template v-if="hasPerm('data_import_logs.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in data_import_log_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != data_import_log.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('data_import_logs.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_data_import_log.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'data_import_logs' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-flex xs12>
                        <v-card elevation="1">
                            <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                                <div v-if="data_import_log.status" class="ribbon ribbon-top-right" :class="`ribbon-${data_import_log.status_class}`">
                                    <span class="ribbon-span">{{ data_import_log.status }}</span>
                                </div>
                                <div v-if="dataImportUploader == true" class="uploading-import">
                                    <v-progress-circular size="48" indeterminate color="white"></v-progress-circular>
                                    <div class="uploading-import-text">Uploading File</div>
                                </div>
                                <v-form ref="formDataImportLog">
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="data_import_log.primary_table_id"
                                            label="Main table *"
                                            :items="sql_table_options"
                                            item-text="table_name"
                                            item-value="table_id"
                                            :rules="ifValid('data_import_logs.primary_table_id')"
                                            @change="getDataImportTableFields"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 :class="!data_import_log.primary_table_id ? 'overlay' : ''">
                                        <input type="file" ref="fileInput" @change="handleFileChange" accept=".csv" />
                                    </v-flex>
                                    <v-flex xs12 :class="!data_import_log.primary_table_id ? 'overlay' : ''">
                                        <table class="v-table">
                                            <thead>
                                                <tr>
                                                    <th class="column text-xs-center">CSV Header</th>
                                                    <th class="column text-xs-center">Database Field</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(header, index) in csv_headers" :key="index">
                                                    <td class="text-xs-center">{{ header }}</td>
                                                    <td class="text-xs-center">
                                                        <bc-autocomplete
                                                            :value="checkForFieldMatch(index, header)"
                                                            placeholder="- Select Field -"
                                                            :items="sql_fields"
                                                            item-text="table_field"
                                                            item-value="field_id"
                                                            @change="indexDataImportFieldMappings(index, $event)"
                                                            clearable
                                                        ></bc-autocomplete>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <!-- <button @click="uploadFile">Upload</button> -->
                                    </v-flex>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @mouseup.left="$router.push({ name: 'data_import_logs' })" flat>{{ $t("lang.cancel") }}</v-btn>
                                <v-btn
                                    v-if="data_import_log.import_id == '' || data_import_log.import_id == null"
                                    color="success"
                                    @click="saveDataImportLogs"
                                    :class="file == null ? 'overlay' : ''"
                                    >{{ $t("lang.upload") }}</v-btn
                                >
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <delete-confirmation-dialog
                ref="delete_data_import_log"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_data_import_log')"
                :message="$t('lang.delete_data_import_log_confirm')"
                @onConfirm="deleteDataImportLogs()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_data_import_log_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteDataImportLogDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [],

            formData: {},
            data_import_log: { file_name: "", file: null, primary_table_id: null, field_mappings: [] },
            file_name: "",
            dbGetDataImportLog: _.debounce(this.getDataImportLog, 1500, { maxWait: 1500, leading: true, trailing: false }),

            file: null,
            csv_headers: [], // Array to store CSV headers
            field_mappings: [], // Object to store field mappings
            sql_fields: null,

            status_loader: false,
            dataImportUploader: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchDataImportLog", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.data_import_logs) {
                        this.data_import_log = this.assignObj2(data.data_import_log, this.rules_data_import_logs);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=data_import_log_status&sort_by=2",
                            method: "get",
                            stateProperty: "data_import_log_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "data_import_logs", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchDataImportLog", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.data_import_logs) {
                        next((vm) => {
                            vm.data_import_log = vm.assignObj2(data.data_import_log, vm.rules_data_import_logs);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=data_import_log_status&sort_by=2",
                                method: "get",
                                stateProperty: "data_import_log_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "data_import_logs", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=data_import_log_status&sort_by=2",
            method: "get",
            stateProperty: "data_import_log_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_data_import_logs: (state) => state.data_import_logs.rules_data_import_logs,
            data_import_log_status_options: (state) => state.settings.data_import_log_status_options,
            data_import_logs: (state) => state.data_import_logs.data_import_logs,
            selectedDataImportLog: (state) => state.data_import_logs.selectedDataImportLog,
            sql_table_options: (state) => state.sql_tables.sql_table_options,
        }),
    },
    methods: {
        ...mapActions([
            "fetchDataImportLog",
            "saveDataImportLog",
            "deleteDataImportLog",
            "printDataImportLog",
            "fetchUserFunctions",
            "fetchSqlTables",
            "fetchDataImportTableFields",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        checkForFieldMatch(index, header) {
            let field = this.sql_fields.find((field) => field.table_field == header);
            this.field_mappings[index] = field !== undefined ? field : {};
            this.data_import_log.field_mappings = this.field_mappings;
            return field ? field.field_id : null;
        },

        handleFileChange(event) {
            this.file = event.target.files[0];
            // Read the CSV file headers
            const reader = new FileReader();
            reader.onload = () => {
                const csvData = reader.result;
                this.data_import_log.file_name = this.file.name;

                const lines = csvData.split(/\r\n|\n/);
                this.csv_headers = lines[0].split(",");
                // Initialize field mappings
                this.csv_headers.forEach(() => {
                    this.field_mappings.push({});
                });

                this.data_import_log.field_mappings = this.field_mappings;

                const dataUrlReader = new FileReader();
                dataUrlReader.onload = (dataUrlEvent) => {
                    const dataUrl = dataUrlEvent.target.result;
                    this.data_import_log.file = dataUrl;
                };

                dataUrlReader.readAsDataURL(this.file);
            };
            reader.readAsText(this.file);
        },
        uploadFile() {
            const formData = new FormData();
            formData.append("csv_file", this.file);
            formData.append("field_mappings", JSON.stringify(this.field_mappings));

            axios
                .post("/api/importCompanies", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    console.log(response.data);
                    // Handle success response
                })
                .catch((error) => {
                    console.error(error);
                    // Handle error response
                });
        },

        getDataImportLog(pg_refresh = false) {
            this.startLoader();

            this.fetchDataImportLog({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.data_import_log) {
                    this.data_import_log = this.assignObj2(data.data_import_log, this.rules_data_import_logs);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        saveDataImportLogs() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formDataImportLog")) {
                    let body = this.prepForm(this.data_import_log, this.rules_data_import_logs);
                    this.dataImportUploader = true;

                    this.saveDataImportLog({
                        body: body,
                    }).then((data) => {
                        this.dataImportUploader = false;
                        if (typeof data != "undefined" && data.data_import_logs) {
                            this.$router.push({ name: "data_import_logs" });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { import_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveDataImportLogs({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.data_import_log) {
                    this.data_import_log = this.assignObj2(data.data_import_log, this.rules_data_import_logs);
                }
            });
        },
        deleteDataImportLogs() {
            this.deleteDataImportLog({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "data_import_logs" });
                }
                this.toggleModalLoader(false);
            });
        },
        getDataImportTableFields() {
            let body = { table_id: this.data_import_log.primary_table_id };
            this.fetchDataImportTableFields({
                body: body,
            }).then((data) => {
                if (typeof data !== "undefined" && data.sql_fields) {
                    this.sql_fields = data.sql_fields;
                }
            });
        },
        indexDataImportFieldMappings(index, field) {
            // get the object from the sql_fields array that matches the field
            let sql_field = this.sql_fields.find((sql_field) => sql_field.field_id == field);
            // set the field mapping for the index to the sql_field

            this.field_mappings[index] = field !== undefined ? sql_field : {};
            this.data_import_log.field_mappings = this.field_mappings;
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchDataImportLog({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.data_import_log) {
                        this.data_import_log = this.assignObj2(data.data_import_log, this.rules_data_import_logs);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.sql_table_options.length == 0 || force == true) await this.fetchSqlTables({ body: { options: 1 } });
        },
    },
    created() {},
};
</script>
<style lang="css" scoped>
.overlay {
    opacity: 0.25;
    pointer-events: none;
}

.uploading-import {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Adjust opacity as needed */
    z-index: 999; /* Ensure the overlay appears on top of other elements */
}
.uploading-import-text {
    color: white;
    margin-top: 10px;
    font-size: 20px;
    font-weight: bold;
}
.uploading-import-text:after {
    display: inline-block;
    animation: dots steps(1, end) 2s infinite;
    content: "";
}
@keyframes dots {
    0% {
        content: "";
    }
    25% {
        content: ".";
    }
    50% {
        content: "..";
    }
    75% {
        content: "...";
    }
    100% {
        content: "";
    }
}
</style>
